export default function InformationSection() {
  return (
    <div className="bg-white rounded-lg shadow-md p-8 mb-8 border border-[#E5E5E5]">
      <div className="flex flex-col">
        <h2 className="text-xl font-bold mb-4 text-[#1D3557]">
          {`Here's how our repayment process works:`}
        </h2>
        <p className="mb-4 text-[#1D3557]">
          <strong className="text-[#4FA0FF]">Single Bullet Repayment: </strong>Your funds are repaid as a
          single lump sum on your due date. We do not offer EMI or
          installment-based repayment plans.
        </p>
        <p className="mb-4 text-[#1D3557]">
          <strong className="text-[#4FA0FF]">Reloan Option:</strong>{" "}
          {`If you need more time to repay, we don't split your repayment into
          EMIs — instead, you can apply for a reloan with an increased loan
          amount to help manage your repayment.`}
        </p>
        <p className="mb-4 text-[#1D3557]">
          <strong className="text-[#4FA0FF]">Online Payment:</strong> We provide a secure online platform
          for you to make your repayment conveniently. Say goodbye to long
          queues and enjoy the ease of digital transactions.
        </p>
        <p className="mb-4 text-[#1D3557]">
          <strong className="text-[#4FA0FF]">Timely Reminders:</strong> We send you timely reminders before
          your repayment due date, helping you stay on top of your obligation.
        </p>
        <p className="mb-4 text-[#1D3557]">
          <strong className="text-[#4FA0FF]">No Hidden Charges:</strong>{" "}
          {`Our commitment to transparency
          means you won't encounter any hidden charges. The amount you agree
          upon during the approval process is what you'll repay – no
          surprises.`}
        </p>
      </div>

      <div className="flex flex-col mt-8">
        <h2 className="text-xl font-bold mb-4 text-[#1D3557]">
          What is the maximum and minimum repayment period at Kubermax?
        </h2>
        <p className="text-[#1D3557]">
          {`At Kubermax, we allow you enough time and flexibility to repay
          your funds. This is done to ensure that repayments don't feel like
          a burden. However, when it comes to the precise duration, the
          minimum repayment period is 7 days, and the maximum repayment
          period is 45 days.`}
        </p>
      </div>
    </div>
  );
}